import CandidatesList from 'components/embeds/stadtrat/candidatesList'
import React, { ReactElement } from 'react'
import './styles.scss'

export default function index(): ReactElement {
  const electionId = 'presidentielle-fr-2022'
  return <CandidatesList electionId={electionId} />
}
